import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { UtilityService } from '../services/utility.service';
import { MasterService } from '../services/master-mom.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup } from '@angular/forms';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import * as Forge from 'node-forge';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute, Params ,NavigationEnd } from '@angular/router';
import { UserService } from '../services/user.service'
import * as $ from 'jquery';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { RSAHelper } from '../services/RSAHelper';
import { UserInfo } from '../userinfo';
import { AuthorizationService } from '../services/authorization.service';
import { TokenResponse } from '@openid/appauth';


@Component({
    selector: 'app-catalog-list',
    templateUrl: './catalog-list.component.html',
    styleUrls: ['./catalog-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ToastrUtilsService]
})

export class CatalogListComponent implements OnInit {
    listview: boolean = false; public modalRef: BsModalRef;
    useremail: string = ""; allapps: any = []; imageLoader: boolean = false; shouldShowcolumn = false;
    userprofileInfo: any = []; subscription: Subscription;
    imgdynamicurl = ''; public authorized: boolean;
    constructor(private utilservice: UtilityService, private authorizationService: AuthorizationService, public RSAHelper: RSAHelper, public router: Router, private userService: UserService, private spinner: NgxSpinnerService, private toastr: ToastrUtilsService, public masterservice: MasterService, private modalService: BsModalService) {
        this.imgdynamicurl = environment.imgdynamicurl;
        // this.Authorize();
    }

    ngOnInit() {

        //to check the existing login
        this.Authorize();

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              window.location.reload(); // Refresh the page
            }
          });

    }


    checkUserDetails() {
        try {
            const user = this.userService.getUserInfo();
            this.listview = true;
            if (!environment.production) {
                this.useremail = environment.testEmail;
            }
            else {
                this.useremail = user.email;
            }
            this.RefreshSecurityToken(this.useremail);
            // this.LoadApplication(this.useremail);

            this.subscription = this.utilservice.getsidebar().subscribe(data => {
                if (this.useremail != null)
                    this.allapps = [];
                //  this.LoadApplication(this.useremail);
            });
        }
        catch (err) {
            console.log(err);
            console.log('call re- authorize');
            setTimeout(function () {
                this.Authorize();
            }, 500);
        }


    }

    Authorize() {

        try {

            this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
                this.authorized = tokenResponse != null;
                if (!this.authorized) {
                    console.log('call authorize');
                    this.authorizationService.authorize();
                    this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse) => {
                        this.authorized = tokenResponse != null;
                        if (this.authorized) {
                            this.checkUserDetails();
                        } else {
                            setTimeout(function () {
                                this.Authorize();
                            }, 500);
                        }
                    });
                } else {
                    this.checkUserDetails();
                }
            });

        }
        catch (err) {
            console.log(err);
            setTimeout(function () {
                this.Authorize();
            }, 500);
        }



    }

    toggleView() {
        this.listview = !this.listview;
    }

    RefreshSecurityToken(userEmail) {
        try {

            const objTxnData = {
                "email": userEmail,
                "isExternal": environment.isExternal
            };
            let encryptedioparam = this.RSAHelper.encryptWithPublicKey(JSON.stringify(objTxnData));
            this.masterservice.refreshToken(JSON.stringify(encryptedioparam)).subscribe((result: any) => {
                sessionStorage.setItem('iammwtoken', result.token);
                this.LoadApplication(this.useremail);

            },
                (error) => {
                    sessionStorage.removeItem('iammwtoken');
                    this.spinner.hide();
                }
            ).add(() => {
                this.spinner.hide();
            });
        }
        catch (err) { console.log(err); }
    }

    //add to recent
    addToRecent(rowData) {
        try {

            //window.open(rowData.applnurl); //moved up from addToRecent result
            this.imageLoader = true;
            this.userService.getUserProfileInfo(this.useremail).
                subscribe((result: any) => {
                    var response;
                    if (result.data == undefined) {
                        response = result;
                        this.userprofileInfo = response;
                    }
                    else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }
                    //const response = result;
                    if (response != null) {
                        const objTxnData = {
                            "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)),
                            "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(rowData.appid.toString())),
                            "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
                            "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail))
                        }

                        this.masterservice.addToRecent(JSON.stringify(objTxnData))
                            .subscribe((result: any) => {
                                const response = result.data;
                                if (response.dictionary.IntResult > 0) {
                                    //window.open(rowData.applnurl);
                                }
                                else {
                                    //this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                }
                            },
                                (error) => {
                                    //this.toastr.ErrorCustomMessage('There was an unexpected error.');
                                    //this.spinner.hide();
                                    this.imageLoader = false;
                                }
                            ).add(() => {
                                //this.spinner.hide();
                                this.imageLoader = false;
                            });
                    }
                });
        }
        catch (err) {
            this.toastr.ErrorCustomMessage('There was an unexpected error.');
            //this.spinner.hide();
            this.imageLoader = false;
            console.log(err);
        }
    }
    getuserprofileinfo() {
        this.userprofileInfo = this.userService.getUserProfileInfo(this.useremail);
    }

    //get all applications
    LoadApplication(userEmail: string) {
        try {
            this.imageLoader = true;
            const objTxnData = {
                "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.useremail)),
                "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify(environment.isExternal)),
            };
            this.masterservice.allApplns(JSON.stringify(objTxnData)).subscribe((result: any) => {
                //this.popupdata = result.data;
                var resultdata = result.data;
                console.log(resultdata);
                for (let i = 0; i < resultdata.length; i++) {
                    //let appid = resultdata[i].appid;
                    //if (this.allapps.filter(item => item.appid === appid) == 0)
                    this.allapps.push(resultdata[i]);
                }
                //console.log(this.allapps);
                this.imageLoader = false;
            },
                (error) => {
                    this.toastr.ErrorCustomMessage('There was an unexpected error.');
                    //this.spinner.hide();
                    this.imageLoader = false;
                }
            ).add(() => {
                //this.spinner.hide();
                this.imageLoader = false;
            });
        }
        catch (err) { console.log(err); this.imageLoader = false; }
    }
}